// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"BO-z","inlineTitle":"CO-z","sponsoredAdsWrapper":"DO-z","marketplaceRecosWrapper":"EO-z"};